export default "__VITE_ASSET__380e61f0__"